module.exports = __webpack_public_path__ + "static/img/Signing.2d12d1f5.jpg";